export function createMomentaryTimeSamplingConfig() {
	return {
		trackerKind: "momentarySampling",
		title: "Momentary Time Sampling",
		instructions: "At each prompt, score whether the target behavior is occurring at that exact moment. Do not score activity before or after the prompt.",
		behaviorLabel: "Target behavior",
		behaviorDefinition: "",
		contextLabel: "Observation context",
		context: "",
		prompt: "Is the target behavior occurring at this exact moment?",
		waitingLabel: "Waiting for the next sampling moment",
		upcomingLabel: "Upcoming",
		missedLabel: "Missed moment",
		completedLabel: "Sampling session complete",
		interruptedLabel: "Sampling session interrupted",
		provisionalLabel: "Provisional",
		unavailableLabel: "Unavailable",
		reviewLabel: "Sampled occurrence estimate",
		reviewNotesLabel: "Private practitioner notes",
		scheduleMode: "fixed",
		intervalSeconds: 30,
		durationSeconds: 1800,
		responseWindowSeconds: 10,
		moments: [],
		options: [{id: "present", title: "Present", status: "present"}, {id: "absent", title: "Not present", status: "absent"}],
	}
}

export function createMomentaryTimeSamplingDemoConfig() {
	return {...createMomentaryTimeSamplingConfig(), intervalSeconds: 5, durationSeconds: 20, responseWindowSeconds: 3}
}

export function createMomentaryTimeSamplingDemoPayload() {
	return {session: {targetBehavior: "Writing in the assigned journal", context: "Independent writing period", autoStart: true}}
}
